<template>
  <v-edit-dialog
    lazy
    large
    cancel-text="Отмена"
    save-text="Ок"
    hide-details
    @cancel="closeDialog"
    @open="openDialog"
    @save="save"
  >
    <div class="link">
      {{ editableValue }}
    </div>
    <v-text-field
      slot="input"
      v-model="editableValue"
      single-line
      autofocus
      outline
      hide-details
      class="my-2"
    />
  </v-edit-dialog>
</template>
<script>
export default {
  props: ["value", "item", "column", "itemIndex"],
  data() {
    return {
      editableValue: "",
    };
  },
  watch: {
    value: {
      handler(value) {
        if (value) {
          this.editableValue = value;
        }
      },
      immediate: true,
    },
  },
  methods: {
    async save() {
      if (!this.editableValue) {
        this.closeDialog();
        return;
      }

      try {
        await this.$store.dispatch("warehouseDetails/assignEditingCell", {
          column: this.column,
          item: this.item,
        });
        await this.$store.dispatch(
          "warehouseDetails/updatePhase",
          this.editableValue,
        );
        this.closeDialog();
        this.showInfo("Изменения сохранены");
      } catch (error) {
        this.editableValue = this.value;
        await this.$store.dispatch("warehouseDetails/assignEditingCell", null);
        this.closeDialog();
        throw error;
      }
    },
    openDialog() {
      this.$emit("openEditDialog", this.itemIndex);
    },
    closeDialog() {
      this.$emit("openEditDialog", null);
    },
  },
};
</script>